import { render, staticRenderFns } from "./198.vue?vue&type=template&id=6c3a050b&scoped=true&"
var script = {}
import style0 from "./198.vue?vue&type=style&index=0&id=6c3a050b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3a050b",
  null
  
)

export default component.exports